import React, { createContext, useContext, useState, useEffect } from 'react';

const DemoAuthContext = createContext();

export const useDemoAuth = () => {
  const context = useContext(DemoAuthContext);
  if (!context) {
    throw new Error('useDemoAuth must be used within a DemoAuthProvider');
  }
  return context;
};

export const DemoAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  // Demo credentials
  const DEMO_CREDENTIALS = {
    'demo@oaklandai.com': {
      id: 'demo-user-1',
      email: 'demo@oaklandai.com',
      name: 'Demo User',
      firstName: 'Demo',
      lastName: 'User',
      isAdmin: false,
      businessType: 'technology',
      language: 'en'
    },
    'admin@oaklandai.com': {
      id: 'admin-user-1',
      email: 'admin@oaklandai.com',
      name: 'Admin User',
      firstName: 'Admin',
      lastName: 'User',
      isAdmin: true,
      businessType: 'consulting',
      language: 'en'
    }
  };

  // Initialize from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('demoUser');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Simple demo login
  const login = async (email, password) => {
    setLoading(true);
    
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const user = DEMO_CREDENTIALS[email];
    
    if (user && password === (email === 'admin@oaklandai.com' ? 'admin123' : 'demo123')) {
      setUser(user);
      localStorage.setItem('demoUser', JSON.stringify(user));
      return { success: true, user };
    } else {
      return { success: false, error: 'Invalid credentials. Use demo@oaklandai.com/demo123 or admin@oaklandai.com/admin123' };
    }
  };

  // Simple logout
  const logout = () => {
    setUser(null);
    localStorage.removeItem('demoUser');
  };

  // Check if user is authenticated
  const isAuthenticated = () => !!user;

  // Check if user is admin
  const isAdmin = () => user?.isAdmin || false;

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated,
    isAdmin
  };

  return (
    <DemoAuthContext.Provider value={value}>
      {children}
    </DemoAuthContext.Provider>
  );
};
